import React, { useState, useRef, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom'

// Style / css
import './ProductCard.css'

// Components
import FavouriteCheckbox from '../../atoms/FavoriteCheckbox'
import PrimaryButton from '../../atoms/PrimaryButton'
import SecondaryButton from '../../atoms/SecondaryButton'
import Timer from '../../../common/timer'
import AddDispute from './AddDispute'

// Context
import AuthContext from '../../../context/auth/authContext'
import CommonContext from '../../../context/common/commonContext'

// Common Function
import { dateFormatFront, dateFormatFrontToEET } from '../../../common/components'
import { handleRedirectInternal } from '../../../common/components'

const Grid = (props) => {
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)

    const { phrase } = commonContext
    const { isAuthenticated, user } = authContext

    const [product, setProduct] = useState()
    const [disputePopup, setDisputePopup] = useState(false)
    const history = useHistory()

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])

    const openDisputePopup = () => {
        setDisputePopup(true)
    }
    const closeDisputePopup = () => {
        setDisputePopup(false)
    }

    let categories = ''
    if (product) {
        for (let i in product.multiplecategoryshow) {
            if (i == product.multiplecategoryshow.length - 1) {
                // last index
                //categories += product.multiplecategoryshow[i]
                categories += phrase[product.multiplecategoryshow[i]]
            } else {
                //categories += product.multiplecategoryshow[i] + ', '
                categories += phrase[product.multiplecategoryshow[i]] + ','
            }
        }
    }

    let dashboardLink = null
    if (props.dashboard && product) {
        if (props.dashboardType == 'won' || props.dashboardType == 'buy_now') {
            dashboardLink = (
                <div>
                    <div className="mb-1">
                        <Link to={`/invoice/${product.invoice_id}`}>
                            <PrimaryButton label={phrase.view + ' ' + phrase.order} />
                        </Link>
                    </div>
                    <div>
                        <PrimaryButton
                            onClick={() => openDisputePopup()}
                            label={phrase.add + ' ' + phrase.dispute}
                        />
                        <AddDispute
                            open={disputePopup}
                            product={product}
                            openDisputePopup={() => openDisputePopup()}
                            closeDisputePopup={() => closeDisputePopup()}
                        />
                    </div>
                </div>
            )
        }
    }

    return (
        <div className="productCardGrid">
            {product ? (
                <>
                    <div className="pcgImg">
                        {(props.dashboard &&
                            props.dashboardType != 'watchlist' &&
                            props.dashboardType != 'active') ||
                        props.completed ? null : user.isBuyer ? (
                            <FavouriteCheckbox
                                watchlisted={product.watchlistid}
                                project_id={product.id}
                                isDashboard={props.dashboard}
                            />
                        ) : null}
                        <Link to={`/product/view/${product.id}`}>
                            <img
                                src={
                                    global.site_url +
                                    '/uploads/product/compressed/' +
                                    product.avatar
                                }
                                alt={product.title}
                            />
                        </Link>
                        {product.market_status == 'open' ? (
                            <div className="TimeSlot">
                                <div className="gridBidInfo d-flex justify-content-center align-items-center">
                                    <p className="hasIt">{phrase.time_left}:</p>
                                    <p className="thisIt">
                                        <span></span>
                                        {product.date_closed ? (
                                            <Timer
                                                date_added={product.date_added}
                                                date_closed={product.date_closed}
                                                withText={0}
                                            ></Timer>
                                        ) : null}
                                    </p>
                                </div>
                            </div>
                        ) : null}

                        {props.completed && <h4 className="aucEnded">Auction Ended</h4>}
                        {isAuthenticated && (
                            <>
                                {product.bidtopstatus === 'outbid' && (
                                    <h4 className="productWinningStatus outbid">OUTBID</h4>
                                )}
                                {product.bidtopstatus === 'winner' && (
                                    <h4 className="productWinningStatus winning">WINNING</h4>
                                )}
                                {product.bidtopstatus === 'won' && (
                                    <h4 className="productWinningStatus won">WON</h4>
                                )}
                                {product.bidtopstatus === 'lost' && (
                                    <h4 className="productWinningStatus lost">LOST</h4>
                                )}
                            </>
                        )}
                    </div>
                    <h2 className="gridProdTitle">
                        <Link to={`/product/view/${product.id}`}>{product.title}</Link>
                    </h2>
                    <div>
                        <div className="gridLotDetails">
                            <p>
                                <label>{phrase.manufacturer}</label>
                                {product.manufacturer}
                            </p>
                            <p>
                                <label>{phrase.model}</label>
                                {product.modelnumber}
                            </p>
                        </div>
                        <div className="gridLotDetails">
                            <p>
                                <label>{phrase.category}</label>
                                {categories}
                            </p>
                            <p>
                                <label>{phrase.size}</label>
                                {product.size}
                            </p>
                        </div>
                        <div className="gridLotDetails">
                            <p>
                                <label>{phrase.condition}</label>
                                {phrase[product.condition_language]}
                            </p>
                            <p>
                                <label>{phrase.quantity}</label>
                                {`${product.qty}`}
                            </p>
                        </div>
                        <div className="gridLotDetails fr1">
                            <p>
                                <label>{phrase.location}</label>
                                {`${product.country}`}
                                {/* {`${product.city}, ${product.state}, ${product.country}`} */}
                            </p>
                        </div>
                        {/*
                        <div className="gridLotDetails">
                            <p>
                                <label> UPC/SKU </label>
                                {product.upc}
                            </p>
                        </div>
                        <div className="gridLotDetails">
                            <p>
                                <label> {phrase.lot_size} </label>
                                {`${phrase[product.lottype]} ${phrase.lot}`}
                            </p>
                            <p>
                                <label> {phrase.auction_type} </label>
                                {product.auctiontype == 'live'
                                    ? phrase.live_auction
                                    : product.auctiontype == 'lineitem'
                                    ? phrase.line_item_auction
                                    : phrase.blind_auction}
                            </p>
                        </div>
                        <div className="gridLotDetails">
                            <p>
                                <label>{phrase.finish}</label>
                                {product.finish}
                            </p>
                        </div>
                        */}
                    </div>
                    {props.completed ||
                    (new Date() < new Date(product.date_closed) &&
                        product.market_status === 'open') ? (
                        <>
                            <div
                                className={
                                    product.market_status === 'open' && !props.completed
                                        ? 'priceTimeCnt priceTimeCntCust hauto'
                                        : 'd-none'
                                }
                            >
                                {product.market_status === 'open' && !props.completed ? (
                                    product.auctiontype !== 'lineitem' ? (
                                        <>
                                            {product.auctiontype == 'live' ? (
                                                <div className="gridBidInfo text-center starting gridBidInfoCust">
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <h6 className="curr">
                                                            {product.latestbid
                                                                ? phrase.current_bid
                                                                : phrase.starting_price}
                                                            :
                                                        </h6>
                                                        <p>
                                                            <span>
                                                                {product.wprice} {product.currency}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <p className="small-text">
                                                        <span>
                                                            {/*product.currency_symbol */}
                                                            {(
                                                                parseFloat(
                                                                    `${product.wprice}`.replaceAll(
                                                                        ',',
                                                                        '',
                                                                    ),
                                                                ) / parseInt(product.qty)
                                                            ).toFixed(2)}{' '}
                                                            {product.currency} / Unit
                                                        </span>
                                                    </p>
                                                </div>
                                            ) : null}

                                            {/* To resolve spacgin issue */}
                                            {product.auctiontype != 'live' ? (
                                                <div className="gridBidInfo d-flex justify-content-between align-items-center"></div>
                                            ) : null}
                                        </>
                                    ) : (
                                        <>
                                            {/* <div className="gridBidInfo d-flex justify-content-between align-items-center">
                                                {product.market_status === 'open' &&
                                                !props.completed ? (
                                                    <>
                                                        <h6>{phrase.time_left}:</h6>
                                                        <p className="d-flex justify-content-between align-items-center">
                                                            <span></span>
                                                            {product.date_closed ? (
                                                                <Timer
                                                                    date_added={product.date_added}
                                                                    date_closed={
                                                                        product.date_closed
                                                                    }
                                                                    withText={0}
                                                                ></Timer>
                                                            ) : null}
                                                        </p>
                                                    </>
                                                ) : null}
                                            </div> */}
                                            <div className="gridBidInfo d-flex justify-content-between align-items-center"></div>
                                        </>
                                    )
                                ) : null}

                                {props.completed ? null : (
                                    <h5 className="prodEndDate">
                                        {dateFormatFrontToEET(product.date_closed)}
                                    </h5>
                                )}
                            </div>

                            <div className={`gridBidBox ${props.completed && 'ended'}`}>
                                <Link to={`/product/view/${product.id}`}>
                                    <PrimaryButton
                                        label={
                                            props.completed
                                                ? phrase.view_ended_auction
                                                : phrase.view
                                        }
                                    />
                                </Link>
                                {/* <Bidding data={product} /> */}
                            </div>
                        </>
                    ) : props.dashboard ? (
                        dashboardLink
                    ) : (
                        <>
                            {product.bidtopstatus === 'won' && (
                                <div className="actionAfterWin">
                                    {parseInt(product.buynowpaid, 10) === 1 ? (
                                        <>
                                            <SecondaryButton
                                                label={phrase.view + ' ' + phrase.order}
                                                btnSize="small"
                                                onClick={() =>
                                                    handleRedirectInternal(
                                                        history,
                                                        `invoice/${product.invoice_id}`,
                                                    )
                                                }
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <PrimaryButton
                                                label="Make payment"
                                                btnSize="small"
                                                onClick={() =>
                                                    handleRedirectInternal(history, 'cart')
                                                }
                                            />
                                        </>
                                    )}
                                </div>
                            )}
                            <div className="gridBidBox">
                                <Link to={`/product/view/${product.id}`}>
                                    <PrimaryButton label={phrase.view_ended_auction} />
                                </Link>
                                {/* <Bidding data={product} /> */}
                            </div>
                        </>
                    )}
                </>
            ) : null}
        </div>
    )
}

export default Grid
